import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';

/**
 * Add the template content to the DOM `n` times.
 *
 * ### Example
 *
 * - <ng-container *flRepeat="3; index as i; repeats as r">
 *     <p>{{ i + 1 }}/{{ r }}</p>
 *   </ng-container>`
 *
 * Should resolve to
 * - <p>1/3</p>
 *   <p>2/3</p>
 *   <p>3/3</p>
 */
@Directive({ selector: '[flRepeat]', standalone: true })
export class RepeatDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  @Input() set flRepeat(repeats: number) {
    for (let index = 0; index < repeats; index++) {
      this.viewContainer.createEmbeddedView(this.templateRef, {
        $implicit: [repeats, index],
        index,
        repeats,
      });
    }
  }
}
